import { useState, useEffect } from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { reservationApi } from '../services/api'

interface Props {
  onSelectDate: (date: string) => void
  selectedDate: string
}

export default function AvailabilityCalendar({ onSelectDate, selectedDate }: Props) {
  const [reservedSlots, setReservedSlots] = useState<{ startAt: string; endAt: string }[]>([])
  const [loading, setLoading] = useState(false)

  const fetchAvailability = async (date: string) => {
    setLoading(true)
    try {
      const response = await reservationApi.getAvailability(date)
      setReservedSlots(response.data.reservations)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (selectedDate) {
      fetchAvailability(selectedDate)
    }
  }, [selectedDate])

  const handleDateChange = (value: any) => {
    const date = value as Date
    const dateStr = date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'Asia/Tokyo'
    }).replace(/\//g, '-')
    onSelectDate(dateStr)
  }

  const formatTime = (dateStr: string) =>
    new Date(dateStr).toLocaleTimeString('ja-JP', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Tokyo'
    })

  const tileDisabled = ({ date }: { date: Date }) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return date < today
  }

  return (
    <div style={styles.container}>
      <Calendar
        onChange={handleDateChange}
        minDate={new Date()}
        tileDisabled={tileDisabled}
        locale="ja-JP"
      />
      {selectedDate && (
        <div style={styles.availability}>
          <h3 style={styles.availabilityTitle}>{selectedDate} の予約状況</h3>
          {loading ? (
            <p style={styles.loading}>読み込み中...</p>
          ) : reservedSlots.length === 0 ? (
            <p style={styles.available}>✅ 終日空きあり</p>
          ) : (
            <div>
              <p style={styles.reserved}>予約済み時間帯：</p>
              {reservedSlots.map((slot, idx) => (
                <div key={idx} style={styles.slot}>
                  🔴 {formatTime(slot.startAt)} 〜 {formatTime(slot.endAt)}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  container: { marginBottom: '24px' },
  availability: {
    marginTop: '16px',
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #eee'
  },
  availabilityTitle: { margin: '0 0 12px 0', color: '#333', fontSize: '16px' },
  loading: { color: '#888', fontSize: '14px' },
  available: { color: 'green', fontWeight: 'bold', fontSize: '14px' },
  reserved: { color: '#e74c3c', fontWeight: 'bold', fontSize: '14px', marginBottom: '8px' },
  slot: {
    padding: '6px 12px',
    backgroundColor: '#ffe0e0',
    borderRadius: '4px',
    fontSize: '14px',
    marginBottom: '4px'
  }
}
